export const initialUserState: UserState = {
	accounts: [],
	loaded: false,
	error: false,
};
